<template>

  <div class="works-filter__inner">
    <div class="works-filter__span">{{ $t("message.ShowFirst") }}:</div>
    <nav class="works-filter__nav">
      <ul>
        <li v-for="option in values">
          <a class="pointer" :class="sort.value==option.value?'active':''" v-on:click="sort=option">{{ option.labelShort }}</a>
        </li>
      </ul>
    </nav>
  </div>

</template>


<script>
  import SortTypeMix from "../../../../../components/list/filter/SortTypeMix";

  export default {
    name      : 'sort-artists-type-sub',
    mixins: [SortTypeMix],

    data() {
      return {
        valuesObj: {
          popular: {
            value: 'popular',
            label: this.$t("message.PopularFirst").toLowerCase(),
            labelShort: this.$t("message.PopularFirstShort").toLowerCase()
          },
          abc: {
            value: 'abc',
            label: this.$t("message.Alphabetically").toLowerCase(),
            labelShort: this.$t("message.Alphabetically").toLowerCase()
          },
          new: {
            value: 'new',
            label: this.$t("message.NewFirst").toLowerCase(),
            labelShort: this.$t("message.NewFirstShort").toLowerCase()
          },
          old: {
            value: 'old',
            label: this.$t("message.OldFirst").toLowerCase(),
            labelShort: this.$t("message.OldFirstShort").toLowerCase()
          },
          period: {
            value: 'period',
            label: this.$t("message.ByYear").toLowerCase(),
            labelShort: this.$t("message.ByYear").toLowerCase()
          },
        },
      }
    },

    computed  : {
      values() {
        let res=[];

        res = [
          this.valuesObj.popular,
          this.valuesObj.new,
          //this.valuesObj.old,
          //this.valuesObj.expert,
          this.valuesObj.abc,
          this.valuesObj.period,
        ];

        res[0].value='';

        return res;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/filter/SortArtistsTypeSub.vue